import styled from '@emotion/styled'
import { Box, FormControl } from '@mui/material'

export const NonProfitOrgSearchContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const Instructions = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const FormControlContainer = styled(FormControl)`
  display: flex;
  flex-direction: row;
  gap: 20px;
  height: 56px;
`

export const Buttons = styled(Box)`
  align-items: center;
  display: flex;
  gap: 20px;
`
